import { stringify } from 'circular-json';
import { contains, join, path, pathOr, pipe, replace, toUpper, trim } from 'ramda';
import { format, parse } from 'url';
import { compact } from 'ramda-adjunct';

const getOriginAndPath = (string: string): string => {
  const parsed = parse(string, false, true);
  const formatted = format({ ...parsed, hash: null, search: null });
  return pipe(
    replace(/_ah\/upload\/.*/, '_ah/upload/'),
    replace(/unsplash\/photos\/.*/, 'unsplash/photos/import'),
  )(formatted);
};

export const isMediaManagerSDKNetworkError = (reason: any): boolean =>
  Boolean(reason && 'code' in reason && 'data' in reason && 'config' in reason);

export const reasonToString = (reason: any): string | undefined => {
  if (!reason) {
    return;
  }

  if (reason instanceof Event) {
    const target = reason.target || path(['path', 0], reason);

    return pipe<string[], string[], string>(
      compact,
      join(''),
    )([
      'Event(',
      reason.type,
      target && target instanceof Node ? `:${target.nodeName.toLowerCase()}` : '',
      ')',
      target instanceof Element ? ` html: '${(target.outerHTML || '').slice(0, 100)}'` : '',
    ]);
  }

  if (isMediaManagerSDKNetworkError(reason)) {
    const { code, message } = reason;

    if (contains(message, ['Wix Session required', 'Site token has expired', 'Tokens mismatch'])) {
      return message;
    }

    const url = pathOr<string, string>('', ['config', 'url'], reason);
    const to = url && getOriginAndPath(url);
    const method = pipe(pathOr('', ['config', 'method']), toUpper)(reason);

    return trim(`${method} request to '${to}' has failed with status ${code} and message '${message}'`);
  }

  if (reason instanceof Error) {
    return `${reason.name || 'Error'}: '${reason.message}'`;
  }

  return stringify(reason);
};
